// Preview-only cards for local chrome. Not product honorarios: price is
// "Por cotizar" until the receptor offers (slice 1).
// taskDeadline is the firm's fecha límite to notify (Task.deadline), not
// dateOffered.
// La API devuelve el día elegido al final del día UTC.
function calendarDeadline(days) {
  const d = new Date();
  return new Date(
    Date.UTC(
      d.getFullYear(),
      d.getMonth(),
      d.getDate() + days,
      23,
      59,
      59,
      999,
    ),
  ).toISOString();
}

export const INBOX_PREVIEW_ITEMS = [
  {
    id: 'preview-1',
    rol: 'C-2104-2026',
    party: 'Estudio Silva / Muñoz',
    tipo: 'Notificación personal',
    comuna: 'Las Condes',
    priceLabel: 'Por cotizar',
    taskDeadline: calendarDeadline(1),
  },
  {
    id: 'preview-2',
    rol: 'C-882-2026',
    party: 'BCI / Lagos',
    tipo: 'Cédula',
    comuna: 'Providencia',
    priceLabel: 'Por cotizar',
    taskDeadline: calendarDeadline(2),
  },
];
